import axiosInstance from "../api/axios";// Adjust the import path as necessary

// Function to fetch notifications
export const fetchNotifications = async (params) => {
  try {
    const response = await axiosInstance.get('/notifications', {
      params,
      
    });

    console.log('Notifications response:', response);
    return response;
  } catch (error) {
    console.error('Error fetching notifications:', error);
    throw new Error('Failed to fetch notifications');
  }
};


// Mark a single in-app notification as read. Degrades gracefully (no throw) so
// the bell UI keeps working even if the endpoint is unavailable.
export const markNotificationRead = async (notificationId) => {
  try {
    const response = await axiosInstance.patch(`/notifications/${notificationId}/read`);
    return response?.data ?? response;
  } catch (error) {
    console.error('Error marking notification read:', error);
    return null;
  }
};

// Mark all of the caller's in-app notifications as read.
export const markAllNotificationsRead = async () => {
  try {
    const response = await axiosInstance.patch('/notifications/read-all');
    return response?.data ?? response;
  } catch (error) {
    console.error('Error marking all notifications read:', error);
    return null;
  }
};


export const fetchCustomerNotificationType = async () => {
  try {
    const response = await axiosInstance.get('/notification/customer/type');

    console.log('Customer notification type response:', response);
    return response;
  } catch (error) {
    console.error('Error fetching customer notification type:', error);
    throw new Error('Failed to fetch customer notification type');
  }
};
